import { RELATION_DEPENDS_ON } from '@backstage/catalog-model';
import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { EntityGridItemProps } from './EntityGridItemProps';

export const DependsOnResourcesGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_DEPENDS_ON,
        kind: 'Resource',
      }}
      title={props.title ?? 'Depends on resources'}
      orderedBy={['spec.type', 'metadata.name']}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'resource' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'resource' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createSpecTypeColumn(),
        EntityTable.columns.createSpecLifecycleColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
